import type {PayloadAction} from '@reduxjs/toolkit';

import {createSlice} from '@reduxjs/toolkit';

import {
  builderGetBanners,
  builderGetHomeData,
  builderGetNotifyDetails,
  builderGetOrderCountData,
  builderGetPerformanceScore,
  builderGetTopSellData,
  builderOrderCount,
  builderPerformance,
  builderUpdateNotifications,
  builderWarehouse
} from './reducer';

const initialState: any = {
  loadingNotifyDetails: false,
  notifyDetailsError: '',
  notifications: [],
  totalScore: 0,
  updatingNotifications: false,
  updatingNotificationsError: '',
  updatingNotificationsSuccess: false,
  gettingHomeData: false,
  gettingHomeDataError: '',
  homeData: {},
  totalScoreHistory: [],
  banners: [],
  // showAddToHomeModal: {
  //   count: 0,
  //   show: false
  // },
  showAddToHomeModal: {
    show: localStorage.getItem('isFirstTime') === 'false' ? false : true
  },
  vendorOverviewData: {},
  performanceData: {},
  orderCountData: {},
  topSellData: {},
  warehouse: {},
  performance: {},
  orderCount: {}
};

export const homeSlice = createSlice({
  name: 'home',
  initialState,
  reducers: {
    toggleAddToHomeModal: (state: any, action: PayloadAction<{show: boolean}>) => {
      localStorage.setItem('isFirstTime', 'false');
      state.showAddToHomeModal = {
        show: action.payload.show
      };
    }
  },
  extraReducers: (builder) => {
    //get notify details
    builderGetNotifyDetails(builder);

    //update notifications
    builderUpdateNotifications(builder);

    //get home data
    builderGetHomeData(builder);

    //get performance data
    builderGetPerformanceScore(builder);

    //get order data
    builderGetOrderCountData(builder);

    //get top sells
    builderGetTopSellData(builder);

    builderOrderCount(builder);

    builderPerformance(builder);

    builderWarehouse(builder);

    builderGetBanners(builder);
  }
});

export const {toggleAddToHomeModal} = homeSlice.actions;
export default homeSlice.reducer;
